import React, { useEffect } from 'react';
import './App.css';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import Features from './components/Features';
import AppShowcase from './components/AppShowcase';
import Footer from './components/Footer';
import Logo from './components/Logo';

function App() {
  // Force scroll to top on mount to prevent browser scroll restoration glitches
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App" style={{ backgroundColor: 'var(--bg-dark)', minHeight: '100vh', position: 'relative' }}>
      <nav style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        padding: '2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 100
      }}>
        <div style={{
          maxWidth: '1400px',
          width: '100%',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Logo />
          <button style={{
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            color: 'var(--text-main)',
            border: '1px solid var(--border-subtle)',
            padding: '0.6rem 1.5rem',
            borderRadius: '4px',
            fontSize: '0.9rem',
            fontWeight: '500',
            backdropFilter: 'blur(10px)',
            transition: 'background-color 0.2s'
          }}>
            Pre-order (Batch 2)
          </button>
        </div>
      </nav>

      <main>
        <Hero />
        <Features />
        <ProblemSolution />
        <AppShowcase />
      </main>

      <Footer />
    </div>
  );
}

export default App;
